/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Hero_DescriptionInputs */

const en_directory_vibebids_hero_description = /** @type {(inputs: Directory_Vibebids_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rank is the bid. Beat the current leader by one dollar and put your product in front of every visitor watching the board.`)
};

const zh_directory_vibebids_hero_description = /** @type {(inputs: Directory_Vibebids_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名由出价决定。只需比当前领先者多出 1 美元，就能让你的产品出现在每一位关注榜单的访客面前。`)
};

/**
* | output |
* | --- |
* | "Rank is the bid. Beat the current leader by one dollar and put your product in front of every visitor watching the board." |
*
* @param {Directory_Vibebids_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_hero_description = /** @type {((inputs?: Directory_Vibebids_Hero_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Hero_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_hero_description(inputs)
	return zh_directory_vibebids_hero_description(inputs)
});
export { directory_vibebids_hero_description as "directory.vibebids.hero_description" }